import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  // {
  //   path: '',
  //   redirectTo: 'live-game',
  //   pathMatch: 'full',
  // },

  {
    path: 'live-game',
    loadChildren: () =>
      import('./pages/live-game/live-game.module').then(
        (m) => m.LiveGamePageModule
      ),
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./pages/login/login.module').then((m) => m.LoginPageModule),
  },
  {
    path: 'player',
    loadChildren: () =>
      import('./pages/player/player.module').then((m) => m.PlayerPageModule),
  },
  {
    path: 'new-game',
    loadChildren: () =>
      import('./pages/new-game/new-game.module').then(
        (m) => m.NewGamePageModule
      ),
  },
  {
    path: 'team-colors',
    loadChildren: () =>
      import('./modals/team-colors/team-colors.module').then(
        (m) => m.TeamColorsPageModule
      ),
  },
  {
    path: 'player-number',
    loadChildren: () =>
      import('./modals/player-number/player-number.module').then(
        (m) => m.PlayerNumberPageModule
      ),
  },
  {
    path: 'stats',
    loadChildren: () =>
      import('./pages/stats/stats.module').then((m) => m.StatsPageModule),
  },
  {
    path: 'teams',
    loadChildren: () =>
      import('./modals/teams/teams.module').then((m) => m.TeamsPageModule),
  },
  {
    path: 'new-player',
    loadChildren: () =>
      import('./modals/new-player/new-player.module').then(
        (m) => m.NewPlayerPageModule
      ),
  },
  {
    path: 'games',
    loadChildren: () =>
      import('./pages/games/games.module').then((m) => m.GamesPageModule),
  },
  {
    path: 'new-event',
    loadChildren: () => import('./pages/new-event/new-event.module').then( m => m.NewEventPageModule)
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
